import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProduct } from '../../../context/ProductContext';
import useWishlist from '../../../hooks/useWishlist';

const LoaderAddProduct = 'https://s3.emmezeta.hr/falcon/loaderAddProduct.gif';
const HeartFillIcon = 'https://s3.emmezeta.hr/falcon/heart-fill.svg';
const HeartIcon = 'https://s3.emmezeta.hr/falcon/heart.svg';

const AddToWishlist = () => {
  const { t } = useTranslation();
  const product = useProduct();
  // Bezpieczne pobieranie właściwości z użyciem operatora ?. i ?? dla domyślnych wartości
  const sku = product?.sku || '';
  const name = product?.name || '';
  const price = product?.prices && Array.isArray(product.prices) && product.prices.length > 0 
    ? product.prices[0].amount 
    : null;

  const { toggleInWishlist, loading, isInWishlist } = useWishlist(sku, name, null, price);

  // Nie renderuj komponentu, jeśli nie ma SKU
  if (!sku) {
    return null;
  }

  return (
    <button
      type="button"
      className="product-item__favorite-link"
      onClick={toggleInWishlist}
      aria-label={isInWishlist ? t('wishlist.removeFromWishlist') : t('wishlist.addToWishlist')}
      disabled={loading}
    >
      <div className="product-item__favorite-icon-wrap">
        {!loading && <img loading="lazy" src={isInWishlist ? HeartFillIcon : HeartIcon} alt={isInWishlist ? t('wishlist.inWishlist') : t('wishlist.addToWishlist')} style={{ width: 25 }} />}
        {loading && <img loading="lazy" src={LoaderAddProduct} alt={t('wishlist.loading')} className="product-item__cart-icon" />}
      </div>
    </button>
  );
};

export default React.memo(AddToWishlist);
